import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=54231a5c&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"
import style0 from "./Master.vue?vue&type=style&index=0&id=54231a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54231a5c",
  null
  
)

export default component.exports